import React from 'react'
import { useDroppable } from '@dnd-kit/core'

interface DroppableFolderItemProps {
  id: string
  selected: boolean
  onClick: () => void
  children: React.ReactNode
}

/** 링크를 드래그해서 떨어뜨릴 수 있는 폴더 항목 */
const DroppableFolderItem: React.FC<DroppableFolderItemProps> = ({
  id,
  selected,
  onClick,
  children,
}) => {
  const { isOver, setNodeRef } = useDroppable({
    id: id,
  })

  return (
    <button
      ref={setNodeRef}
      onClick={onClick}
      className={`flex w-full items-center rounded-md px-3 py-2 text-sm transition-colors 3xl:px-3 3xl:py-2 3xl:text-base 7xl:px-4 7xl:py-2.5 7xl:text-lg ${
        selected
          ? 'border border-blue-200 bg-blue-50 text-blue-700 dark:border-blue-800 dark:bg-blue-900/20 dark:text-blue-300'
          : 'text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700'
      } ${
        isOver
          ? 'border-2 border-dashed border-blue-300 bg-blue-100 dark:border-blue-600 dark:bg-blue-900/30'
          : ''
      }`}
    >
      {children}
    </button>
  )
}

export default DroppableFolderItem
